import type { GetObligationAssessmentResultAuditByIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetObligationAssessmentResultAuditByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetObligationAssessmentResultAuditByIdArgs = {
  id: string;
};

export const useGetObligationAssessmentResultAuditById = createQueryHook<
  UseGetObligationAssessmentResultAuditByIdArgs,
  GetObligationAssessmentResultAuditByIdQuery['obligation_assessment_result_audit'],
  GetObligationAssessmentResultAuditByIdQuery
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.auditLog.getObligationAssessmentResultAuditById.queryOptions({
      id,
    }),
  mapTrpcDataToGraphQL: (data) => ({
    obligation_assessment_result_audit: data,
  }),
  graphqlDocument: GetObligationAssessmentResultAuditByIdDocument,
  graphqlVariables: ({ id }) => ({ Id: id }),
});
